/*eslint-disable */
import React, { useEffect, useState } from "react";
import MenuLayouts from "../layouts/menu.layout";
import FooterLayouts from "../layouts/footer.layout";
import BtnFloatingLayout from "../layouts/btn_flotante.layout";
import BannerMundialComponent from "../components/multi_cotizacion/banner-mundial.component";
import VideoMundialComponent from "../components/multi_cotizacion/video-mundial.component";
import ComoParticiparComponent from "../components/multi_cotizacion/como-participar.component";
import TerminosMundialComponent from "../components/multi_cotizacion/terminos-mundial.component";
import MenuMundialComponent from "../components/multi_cotizacion/menu-mundial.component";
import BannerComponent from "../components/multi_cotizacion/banner.component";
import DescriptionComponent from "../components/multi_cotizacion/description.component";
import CotizacionVehiculosComponent from "../components/multi_cotizacion/cotizacion-vehiculos.component";
import {
  multicotizador,
  vehiclesSimulator,
} from "../components/conexion/vehicles.conexion";
import "../assets/css/mundial-page-bg.css";
import "../assets/css/cotizador-mundial-override.css";
import heroBannerImage from "../assets/02_Assets/banner-1.webp";
import heroBannerPortraitImage from "../assets/02_Assets/hero-banner-portrait.webp";
import VehiculosMundialComponent from "../components/multi_cotizacion/vehiculos_mundial.component";
import CotizacionVehiculosMundialComponent from "../components/multi_cotizacion/cotizacion-vehiculos-mundial.component";

const MultiCotizacionMundialPage: React.FC = () => {
  const [visibleHeight, setVisibleHeight] = useState(0);
  const [vehiculosData, setVehiculosData]: any = useState([]);
  const [vehiculosSelected, setVehiculosSelected]: any = useState(null);
  const [multicotizadorData, setMulticotizadorData]: any = useState([]);

  // NUEVO ESTADO PARA DETECTAR SCROLL Y OCULTAR MENU PRINCIPAL
  const [isScrolled, setIsScrolled] = useState(false);
  const [isPortrait, setIsPortrait] = useState(false);

  useEffect(() => {
    setIsPortrait(window.innerHeight > window.innerWidth);
    const handleResize = () => {
      setIsPortrait(window.innerHeight > window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const slugToVehicleName: Record<string, string> = {
      "creta": "CRETA",
      "grand-i10": "Grand i10",
      "grand-metro-taxi-hatchback": "GRAND METRO HATCHBACK",
      "grand-metro-taxi-sedan": "GRAND METRO SEDÁN",
      "hb20-hatchback": "HB20 Hatchback",
      "hb20s-sedan": "HB20S Sedán",
      "ioniq-5": "IONIQ 5",
      "kona-electrica": "KONA Eléctrica",
      "kona-gasolina": "KONA Gasolina",
      "kona-hibrida": "KONA Híbrida",
      "kona-n-line": "KONA Híbrida N Line",
      "palisade": "PALISADE",
      "santa-fe-hibrida": "SANTA FE Híbrida",
      "staria-lujo": "STARIA lujo",
      "staria-panel": "STARIA panel",
      "staria-pasajeros": "STARIA pasajeros",
      "tucson": "TUCSON Gasolina",
      "tucson-hibrida": "TUCSON Híbrida",
      "venue": "VENUE"
    };

    const urlParams = new URLSearchParams(window.location.search);
    let selectedSlug = urlParams.get("vehiculo");
    
    if (!selectedSlug) {
        const hash = window.location.hash.replace("#", "");
        if (hash && slugToVehicleName[hash]) {
            selectedSlug = hash;
        }
    }

    const targetVehicleName = selectedSlug ? slugToVehicleName[selectedSlug] : null;

    vehiclesSimulator().then(function (res: any) {
      let data: any = res?.data?.data;

      if (data) {
        const allowedVehicles = [
          "TUCSON Híbrida",
          "TUCSON Gasolina",
          "Grand i10",
          "SANTA FE Híbrida",
          "VENUE",
          "KONA Híbrida",
          "KONA Híbrida N Line",
          "KONA Gasolina",
          "KONA Eléctrica"
        ];
        
        if (targetVehicleName && !allowedVehicles.includes(targetVehicleName)) {
           allowedVehicles.push(targetVehicleName);
        }

        data = data.filter((v: any) => allowedVehicles.includes(v.name));
        data.sort((a: any, b: any) => allowedVehicles.indexOf(a.name) - allowedVehicles.indexOf(b.name));
      }

      setVehiculosData(data);
      if (data && data.length > 0) {
        if (targetVehicleName) {
            const found = data.find((v: any) => v.name === targetVehicleName);
            setVehiculosSelected(found || data[0]);

            setTimeout(() => {
              const element = document.getElementById("cotizacion");
              if (element) {
                const offsetTop = element.offsetTop - 120;
                window.scrollTo({
                  top: offsetTop,
                  behavior: "smooth",
                });
              }
            }, 500);
        } else {
            setVehiculosSelected(data[0]);
        }
      }
    });

    multicotizador().then(function (res: any) {
      setMulticotizadorData(res?.data?.data);
    });
  }, []);

  return (
    <>
      <div
        style={{
          transition: "transform 0.4s ease-in-out, opacity 0.4s ease-in-out",
          transform: isScrolled ? "translateY(-100%)" : "translateY(0%)",
          opacity: isScrolled ? 0 : 1,
          pointerEvents: isScrolled ? "none" : "auto",
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: 1000
        }}
      >
        <MenuLayouts
          className="home-page"
          active="somos"
          setVisibleHeight={setVisibleHeight}
          visibleHeight={visibleHeight}
        />
      </div>
      <div
        className="home-page mundial-page-parallax-bg" /* style={{backgroundColor: "#F6F3F2", height: "100vh"}} */
      >
        <h1
          style={{ position: "absolute", opacity: "0", pointerEvents: "none" }}
        >
          Multicotización Hyundai Colombia - Compara y Encuentra tu Mejor Opción
        </h1>

        <div className="home-page-mascara"></div>
        <MenuMundialComponent visibleHeight={visibleHeight} />
        <BannerComponent multicotizadorData={multicotizadorData} customImage={isPortrait ? heroBannerPortraitImage : heroBannerImage} />
        <VideoMundialComponent />
        <BannerMundialComponent multicotizadorData={multicotizadorData} />
        <ComoParticiparComponent />
        {/* <DescriptionComponent multicotizadorData={multicotizadorData} /> */}

        <div className="cotizacion-multiple-component sin-background" id="cotizacion">

          <div className="mundial-cotizador-header">
            <h2>Agenda tu test drive</h2>
            <p>Selecciona el Hyundai que deseas cotizar</p>
          </div>

          <VehiculosMundialComponent
            vehiculosData={vehiculosData}
            setVehiculosSelected={setVehiculosSelected}
            vehiculosSelected={vehiculosSelected}
          />
          {vehiculosSelected !== null ? (
            <CotizacionVehiculosMundialComponent vehiculo={vehiculosSelected} />
          ) : null}
        </div>
        {/* <TerminosMundialComponent /> */}
      </div>
      <BtnFloatingLayout reserva="https://reservas.hyundaicolombia.co/" />
      <FooterLayouts />
    </>
  );
};

export default MultiCotizacionMundialPage;
